const getAddCompanyDialogController = () => import('../../dialogs/add-company/add-company-dialog.controller')

/* @ngInject */
function GeneralBackofficeController ($scope, $rootScope, $translate, $timeout, AdminService, UdsModalService, ToastService, Utils) {
  $scope.flags = {
    loading: true
  }
  $scope.filters = {
    search: '',
    status: []
  }
  $scope.pageTitle = ''
  $scope.companiesTableInfo = {
    tooltip: '',
    emptyMode: {
      title: $translate.instant('generalBackoffice.companies.table.emptyMode.title'),
      description: $translate.instant('generalBackoffice.companies.table.emptyMode.description'),
      button: {
        text: $translate.instant('generalBackoffice.companies.table.emptyMode.button.text'),
        icon: 'store',
        buttonClick: _openNewCompanyDialog
      }
    },
    columns: [
      { name: 'ID', orderable: false, value: 'companyId' },
      { name: $translate.instant('name'), orderable: false, value: 'name' },
      { name: $translate.instant('activeUsersQuotaErrorTitle'), orderable: false, value: 'maxLicenses' },
      { name: $translate.instant('status'), orderable: false, value: 'status' }
    ],
    columnsGrid: '10% 40% 20% 25% 5%',
    rows: [],
    editButton: {
      unlockCompanyAccess: (companyId) => {
        $rootScope.getUser().then((user) => {
          AdminService.userExistsInCompany({
            companyId,
            userId: user.id
          }).then((userExists) => {
            if (userExists) {
              ToastService.showErrorToast($translate.instant('generalBackoffice.companies.toast.alreadyHaveCompanyAccess'))

              return
            }

            AdminService.addUserToCompany(user.email, [], companyId).then(() => {
              ToastService.showSuccessToast($translate.instant('generalBackoffice.companies.toast.unlockedCompanyAccess'))
              const rowToUpdate = $scope.companiesTableInfo.rows.find(row => row.id === companyId)
              rowToUpdate.userHasAccess = true
            })
          })
        })
      },
      dropdown: true
    },
    refresherCounter: 0,
    paging: {
      top: 16,
      count: 0,
      index: 0,
      onTokenSelect: _skipPagingTo
    },
    updateFilters: _updateFilters
  }

  const api = {
    _openNewCompanyDialog,
    _skipPagingTo,
    _handleGetCompanies,
    _updateFilters,
    _onSearch: Utils.debounce(_onSearch),
    _setHeader
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._skipPagingTo(null, 0)
    api._setHeader()
  }

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('generalBackoffice.companies.table.title')
  })

  function _openNewCompanyDialog () {
    getAddCompanyDialogController().then(({ AddCompanyDialogController }) => {
      const addCompanyDialog = UdsModalService.createModal({
        controller: AddCompanyDialogController,
        modalName: 'addCompanyDialog',
        onClose: (isSuccess) => {
          if (isSuccess) {
            api._skipPagingTo(null, 0)
          }
        }
      })

      addCompanyDialog.open()
    })
  }

  function _skipPagingTo (event, token) {
    token = event ? event.detail.currentPage - 1 : token
    $scope.companiesTableInfo.paging.index = token
    $scope.flags.loading = true

    AdminService.getAllCompanies({
      $top: $scope.companiesTableInfo.paging.top,
      $skip: $scope.companiesTableInfo.paging.top * token,
      filters: $scope.filters
    })
      .then(api._handleGetCompanies)
      .finally(() => {
        $scope.flags.loading = false
      })
  }

  function _handleGetCompanies (response) {
    const rows = response.rows
    const totalCount = response.count

    $scope.companiesTableInfo.paging.count = totalCount
    $scope.companiesTableInfo.rows = rows.map(company => {
      return {
        id: company.id,
        companyId: company.id,
        name: company.formattedName,
        maxLicenses: company.maxLicenses,
        status: company.status,
        userHasAccess: $rootScope?.userCompanies?.some(userCompany => userCompany.customerCompanyId === company.id && userCompany.active),
        values: [
          { type: 'TEXT', value: company.id },
          { type: 'TEXT', value: company.formattedName },
          { type: 'COUNT_LABEL', value: company.maxLicenses, label: $translate.instant('users') },
          { type: 'TEXT', value: $translate.instant(`generalBackoffice.companies.table.statusColumn.${company.status}`) }
        ]
      }
    })

    $scope.loading = false
    $timeout(() => {
      $scope.$broadcast('core-table.updateGrid')
    }, 0)
  }

  function _updateFilters (filter, value) {
    if (filter !== 'search') {
      return
    }
    $scope.filters.search = value

    api._skipPagingTo(null, 0)
  }

  function _onSearch (term) {
    api._updateFilters('search', term)
  }

  function _setHeader () {
    if ($rootScope.isDesktop) {
      $scope.headerToolbar = {
        rightButtons: [{
          type: 'button',
          btnType: 'primary',
          icon: 'store',
          label: $translate.instant('generalBackoffice.companies.button.text'),
          onClick: api._openNewCompanyDialog
        }],
        search: {
          onSearch: api._onSearch
        },
        filter: {
          params: {
            companyStatus: []
          },
          items: [
            { id: 1, name: 'COMPANY_STATUS', order: 1 }
          ]
        }
      }
    } else {
      $scope.headerToolbar = {
        rightButtons: [{
          type: 'button',
          btnType: 'primary',
          icon: 'store',
          label: $translate.instant('new'),
          onClick: api._openNewCompanyDialog
        }],
        search: {
          onSearch: api._onSearch
        }
      }
    }
  }

  const deregisterCompanyStatusWatcher = $scope.$watch('headerToolbar.filter.params.companyStatus', (newValue) => {
    $scope.filters.status = newValue
    api._skipPagingTo(null, 0)
  })

  $scope.$on('$destroy', () => {
    deregisterCompanyStatusWatcher()
  })
}

export { GeneralBackofficeController }
